import React from "react";

import { TabType } from "@constants";

type FiltersMobileCloseHandleProps = {
  type: TabType;
};

const FiltersMobileCloseHandle: React.FC<FiltersMobileCloseHandleProps> = ({ type }) => {
  return (
    <div id={`filters-home-indicator-${type}`} className="filters__home-indicator">
      <div className="filters__home-indicator-handle" />
    </div>
  );
};

export default FiltersMobileCloseHandle;
